// extracted by mini-css-extract-plugin
export default {"answer":"M9-z","bestAnswerHeading":"N9-z","meta":"O9-z"};